import { useEffect, useState } from 'react';

import {
  icTda,
  icCda,
  icMl,
  icCoinGold,
  icHandshake,
} from '@/components/GenericsTournaments/Icons';
import { EnumContextGDT } from '@/types/team';

interface ContextData {
  icon: string;
}

// Definimos todos los datos de contexto posibles
const DATA_CONTEXT: Partial<Record<EnumContextGDT, ContextData>> = {
  [EnumContextGDT.FriendTournament]: {
    icon: icTda,
  },
  [EnumContextGDT.FriendsCup]: {
    icon: icCda,
  },
  [EnumContextGDT.Minileagues]: {
    icon: icMl,
  },
  [EnumContextGDT.GoldDate]: {
    icon: icCoinGold,
  },
  [EnumContextGDT.Challenge]: {
    icon: icHandshake,
  },
};

interface Props {
  context?: EnumContextGDT;
}

export const useIconsByContext = ({
  context = EnumContextGDT.FriendTournament,
}: Props) => {
  const [state, setState] = useState('');

  useEffect(() => {
    const data = DATA_CONTEXT[context];
    if (data) {
      setState(data.icon);
    } else {
      setState('');
    }
  }, [context]);

  if (!state) {
    return null;
  }

  return { icon: state };
};
